import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, AwaitModules, ComponentSync, TS_ErrorBoundary, TS_Loader } from '@nu-art/thunderstorm-frontend/index';
import { cloneObj, filterDuplicates, MUSTNeverHappenException, resolveContent } from '@nu-art/ts-common';
import { ModuleFE_Account } from '../../_entity/account/index.js';
import { TS_Icons } from '@nu-art/ts-styles';
import './Component_AccountThumbnail.scss';
export const Component_AccountThumbnail = (props) => {
    const { modulesToAwait, ...rest } = props;
    const modules = [...(modulesToAwait ?? []), ModuleFE_Account];
    return _jsx(AwaitModules, { modules: filterDuplicates(modules), customLoader: () => _jsx(TS_Loader, { className: 'user-thumbnail__loader' }), children: _jsx(Component_AccountThumbnail_Impl, { ...rest }) });
};
class Component_AccountThumbnail_Impl extends ComponentSync {
    // ######################### Lifecycle #########################
    shouldReDeriveState() {
        return true;
    }
    __onAccountsUpdated = (...params) => {
        this.reDeriveState();
    };
    deriveStateFromProps(nextProps, state) {
        const accountId = resolveContent(nextProps.accountId);
        state.account = ModuleFE_Account.cache.unique(accountId);
        if (!state.account)
            throw new MUSTNeverHappenException(`Could not find account for id ${accountId}`);
        state.acronym = this.generateThumbnailAcronym(state.account);
        return state;
    }
    // ######################### Logic #########################
    generateThumbnailAcronym(account) {
        const accountAcronym = account.displayName ? account.displayName.substring(0, 2).toUpperCase() : account.email.substring(0, 2).toUpperCase();
        if (!this.props.acronymComposer)
            return accountAcronym;
        return this.props.acronymComposer(account._id) ?? accountAcronym;
    }
    onClick = (e) => {
        if (!this.props.onClick || !this.state.account)
            return;
        this.props.onClick(e, cloneObj(this.state.account));
    };
    // ######################### Render #########################
    render() {
        const className = _className('user-thumbnail', this.props.onClick && 'clickable');
        return _jsx(TS_ErrorBoundary, { children: _jsxs("div", { className: className, onClick: this.onClick, children: [this.renderContent(), this.renderImageUploadOverlay()] }) });
    }
    renderContent = () => {
        if (this.state.account?.thumbnail)
            return this.renderUserImage();
        return _jsx("div", { className: 'user-thumbnail__acronym', children: this.state.acronym });
    };
    renderUserImage = () => {
        const src = `data:image/jpeg;base64,${this.state.account.thumbnail}`;
        return _jsx("img", { src: src, alt: 'user-image', className: 'user-thumbnail__image' });
    };
    renderImageUploadOverlay = () => {
        if (this.props.onClick !== ModuleFE_Account.uploadAccountThumbnail)
            return;
        return _jsx("div", { className: 'user-thumbnail__upload-image-overlay', children: _jsx(TS_Icons.addImage.component, {}) });
    };
}
//# sourceMappingURL=Component_AccountThumbnail.js.map